import BasicRepository, {AllArgs, ListArgs} from "./basicRepository";
import Client from "../client";
import ArtifactResource from "client/resources/artifactResource";

interface ArtifactListArgs extends ListArgs {
    regarding?: string;
    order?: string;
}

class ArtifactRepository extends BasicRepository<ArtifactResource, ArtifactResource, ArtifactListArgs> {
    constructor(client: Client) {
        super("Artifacts", client);
    }
}

export default ArtifactRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/artifactRepository.ts